export default "__VITE_ASSET__Bpwf6ytM__"